module.exports = __webpack_public_path__ + "static/media/imagotipo.d7eb0ac3.svg";